import type { InboxLabelFragment } from "@qw/graphql";

export interface LabelArrayItem {
  displayName: string;
  name: string;
  externalId: string;
  children?: LabelArrayItem[];
}

export interface LabelTreeNode {
  displayName: string;
  name: string;
  externalId: string;
  children: Map<string, LabelTreeNode>;
}

export function convertLabelPathsToNested(labels: InboxLabelFragment[]): LabelArrayItem[] {
  const tree = new Map<string, LabelTreeNode>();

  // Create a map of full paths to externalIds
  const pathToExternalId = new Map<string, string>();
  labels.forEach((label) => pathToExternalId.set(label.name, label.externalId));

  labels.forEach((label) => {
    const parts = label.name.split("/");
    let level = tree;
    let currentPath = "";

    parts.forEach((part, index) => {
      currentPath = index === 0 ? part : `${currentPath}/${part}`;

      if (!level.has(part)) {
        level.set(part, {
          displayName: part,
          name: currentPath,
          externalId: pathToExternalId.get(currentPath) || "",
          children: new Map<string, LabelTreeNode>(),
        });
      }
      level = level.get(part)!.children;
    });
  });

  const toArray = (map: Map<string, LabelTreeNode>): LabelArrayItem[] =>
    [...map.values()].map((node) => ({
      displayName: node.displayName,
      name: node.name,
      externalId: node.externalId,
      ...(node.children.size > 0 && { children: toArray(node.children) }),
    }));

  return toArray(tree);
}
